export default __webpack_public_path__ + "static/media/audio-square.105d17d2.jpg";